import { z } from "zod";
import { createCodec } from "../codec";

const ProductApiSchema = z.object({
  id: z.number(),
  branch_id: z.number(),
  id_product: z.number(),
  name: z.string(),
  editable_quantity: z.number().nullable().optional(),
  editable_amount: z.number().nullable().optional(),
  quantity: z.number(),
  amount: z.number(),
});

const ProductCodec = createCodec({
  apiSchema: ProductApiSchema,
  deserialize: (api) => ({
    id: api.id,
    branch: api.branch_id,
    productId: api.id_product,
    name: api.name,
    editableQuantity: api.editable_quantity === 1,
    editableAmount: api.editable_amount === 1,
    quantity: api.quantity,
    amount: api.amount,
  }),
  serialize: (app) => ({
    id: app.id,
    branch_id: app.branch,
    id_product: app.productId || 0,
    name: app.name,
    editable_quantity: undefined,
    editable_amount: undefined,
    quantity: app.quantity,
    amount: app.amount,
  }),
});

type Product = z.output<typeof ProductCodec.schema>;
type ProductApi = z.input<typeof ProductCodec.schema>;

export { ProductCodec, type Product, type ProductApi };
